function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionCouponRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 13V6a2 2 0 00-2-2H4a2 2 0 00-2 2v7a3 3 0 010 6v7a2 2 0 002 2h24a2 2 0 002-2v-7a3 3 0 010-6zm-17 5h-2v-4h2v4zm0-6h-2V8h2v4zm0 12h-2v-4h2v4z",
    fill: props.color
  }));
}

export default SvgIconPromotionCouponRexFilled;